import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchSocialAppGoogle, addUpdateSocialApp, updateSocialStatus } from '../../store/actions/socialAppAction'
import { Grid, Typography, Button, TextField, Switch, Avatar } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { makeStyles } from '@material-ui/core/styles';
import env from "../../env"

const useStyles = makeStyles((theme) => ({
    
  }));

const Google = () => {
      const dispatch = useDispatch()
      const {id} = useParams()
      const category = 'googleLogin'

      const [active, setActive] = useState(false);
      const [ input, setInput ] = useState({
        clientId: '',
        clientSecret: ''
      })
      const classes = useStyles();
    
      useEffect(() => {
          dispatch(fetchSocialAppGoogle(id, category))
        return () => {
            const cleanupInput = {
                clientId: '',
                clientSecret: ''
            }
          setInput(JSON.parse(JSON.stringify(cleanupInput)))
        }  
      }, [dispatch, id, category])
      
      const socialApp = useSelector(state => state.socialAppReducer.socialAppGoogle)
      const loading = useSelector(state => state.socialAppReducer.loading)

      
      useEffect(() => {
          if (socialApp) {
              const newInput = {
                  clientId: socialApp.clientId,
                  clientSecret: socialApp.clientSecret
              }
              setActive(socialApp.status === 'active')
              setInput(JSON.parse(JSON.stringify(newInput)))              
          } else {
            const newInput = {
              clientId: '',
              clientSecret: ''
            }
            setActive(false)
            setInput(JSON.parse(JSON.stringify(newInput)))
          }
      }, [socialApp])

   
      const handleSwitchChange = (e) => {
        setActive(e.target.checked);
        const payload = {appId:id, category, status: e.target.checked }
        dispatch(updateSocialStatus(payload))
      };

      const handleFormChange = (e) => {
          let { name, value } = e.target
          setInput({ ...input, [name]: value })
      }
                
      const handleSubmit = (e) => {
        e.preventDefault()
        input.appId = id
        input.category = category
        dispatch(addUpdateSocialApp(input))
      }

      async function googleLogin () {
        const redirectUri = `${env.REACT_APP_BE_URL}/auth/${id}/callback`;
        await openGoogleDialog(redirectUri);
      }
      
      const buildUrlGoogle = (redirectUri) => {
        const payloadParams =  { clientId: input.clientId, clientSecret: input.clientSecret, category, type:'testConnection' }
        const params = JSON.stringify(payloadParams)
    
        const scope = "https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email"
        const uriX2 = encodeURIComponent(redirectUri);
        return (`https://accounts.google.com/o/oauth2/v2/auth?scope=${scope}&access_type=offline&include_granted_scopes=true&response_type=code&state=${params}&redirect_uri=${uriX2}&client_id=${input.clientId}`)
    }
    
    const openGoogleDialog = async (redirectUri) => {
        try {
            const uri = await buildUrlGoogle(redirectUri);
            window.open(uri)
        } catch (error) {
            console.log(error);
        }
    }

    const [values, setValues] = useState({
        password: '',
        showPassword: false,
    });

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };
    
    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };
  
    const handleChangePassword = (prop) => (e) => {
      setValues({ ...values, [prop]: e.target.value });
      let { name, value } = e.target
      setInput({ ...input, [name]: value })
  
    };

    if (loading) return <div>Loading</div>

    return (
        <div>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                className="mb-15">
                <Grid item>
                    <Typography className="d-flex reguler" style={{flexDirection: "row", justifyContent: "center"}}>
                        <img alt="google logo" src="/icon-google.png" style={{width: "25px"}}/> &ensp; Google/Gmail
                    </Typography>        
                </Grid>
                <Grid item>
                    <span className="mb-0 reguler text-grey font-size-14">
                        Status: 
                        <span>Enable</span>
                    </span>
                    <Switch
                        checked={active}
                        onChange={handleSwitchChange}
                        color="primary"
                        name="checked"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />        
                </Grid>
            </Grid>
            {
                active && 
                <div>
                    <form onSubmit={handleSubmit}>
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Client ID</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        id="clientId"
                        name="clientId"
                        value={input.clientId}
                        autoFocus
                        onChange={handleFormChange}
                        />
                        <p className="font-size-16 reguler text-darkgrey mt-10" style={{marginBottom: "-5px"}}>Client Secret</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        name="clientSecret"
                        id="clientSecret"
                        type={values.showPassword ? 'text' : 'password'}
                        value={input.clientSecret}
                        autoFocus
                        onChange={handleFormChange}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <div className="d-flex mt-15" style={{justifyContent: "flex-end"}}>
                            <Button
                                className="btn-white text-transform-unset"
                                spacing={5}
                                onClick={() => googleLogin()}
                                style={{padding: "5px 40px", marginRight: "20px"}}
                            >
                                Test Koneksi
                            </Button>
                            <Button
                                type="submit"
                                className="btn-black text-transform-unset"
                                spacing={5}
                                style={{padding: "5px 40px"}}
                            >
                                Save
                            </Button>
                        </div>
                </form>
                </div>
            }
        </div>
    )
}

export default Google
